import { recentDonors } from '@/mocks/dashboard';
import SAR from '@/components/feature/SAR';

const DashboardDonors = () => {
  const fmt = (n: number) =>
    new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(n);

  return (
    <div className="bg-white rounded-2xl border border-stone-100 p-5">
      <div className="flex items-center justify-between mb-5">
        <h3 className="font-black text-stone-800 text-base">آخر الداعمين</h3>
        <span className="text-xs text-stone-400">{recentDonors.length} داعم</span>
      </div>

      <div className="space-y-3">
        {recentDonors.map((donor) => (
          <div key={donor.id} className="flex items-start gap-3">
            {/* Avatar */}
            <div className="relative shrink-0">
              <img
                src={donor.avatar}
                alt={donor.name}
                className="w-9 h-9 rounded-full object-cover object-top"
              />
              {donor.isAnonymous && (
                <div className="absolute inset-0 bg-stone-200 rounded-full flex items-center justify-center">
                  <i className="ri-user-line text-stone-500 text-sm"></i>
                </div>
              )}
            </div>

            {/* Info */}
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between gap-2">
                <span className="text-xs font-bold text-stone-800 truncate">
                  {donor.isAnonymous ? 'داعم مجهول' : donor.name}
                </span>
                <span className="text-xs font-black text-emerald-600 shrink-0">
                  +<SAR amount={donor.amount} iconSize={11} />
                </span>
              </div>
              {donor.message && (
                <p className="text-xs text-stone-500 mt-0.5 leading-relaxed line-clamp-1">
                  "{donor.message}"
                </p>
              )}
              <span className="text-xs text-stone-400">{donor.date}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardDonors;
